const en = {
  navigation: {
    plantHalts: "Fermi impianto",
    plantHaltsRicSg: "San Giorgio plant halts"
  },
  list: {
    lineTotals: "Totals by line",
    allLinesTotal: "All lines total",
    noLine: "No line",
    lineDisabled: "disabled",
    lineFullyDisabled: "line disabled for the whole shift",
    causeTotals: "Totals by cause",
    allCausesTotal: "All causes total",
    excludedFromTotal: "excluded from the total",
    filter: {
      shift: "Shift",
      shiftOption: "Shift {{number}} ({{from}} - {{to}})"
    }
  }
};

export default { plantHalts: en };
